import React from 'react';
import {
    Facebook,
    X,
    Instagram,
    WhatsApp
} from '@mui/icons-material';

export default function Footer() {
  return (
    <div className="footer-container rounded-t-3xl bg-gradient-to-b from-amber-950 to-black w-full max-sm:static ">
        <div className="footer-top py-4 border-b border-b-gray-400 flex flex-col md:flex-row">
            <div className="footer-top-left w-full md:w-1/2 flex justify-center">
                <img src="../assets/footer-logo.png" alt="footer-logo" className="w-1/2 md:w-1/5" />
            </div>
            <div className="footer-top-right w-full md:w-1/2 flex items-center justify-center text-white mt-4 md:mt-0">
                <a href=""><Facebook sx={{fontSize:28}} className='mx-3.5 hover:text-gray-400' /></a>
                <a href=""><X sx={{fontSize:28}} className='mx-3.5 hover:text-gray-400'/></a>
                <a href=""><Instagram sx={{fontSize:28}} className='mx-3.5 hover:text-gray-400' /></a>
                <a href=""><WhatsApp sx={{fontSize:28}} className='ml-3.5 hover:text-gray-400' /></a>
            </div>
        </div>
        <div className="footer-bottom text-center py-3.5 text-white">
            <span>© 2024 TSOFIE. All rights reserved</span>
        </div>
    </div>
  );
}